import { Injectable } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DialogService } from '../dialog/dialog.service';
import { FileSaverService } from 'ngx-filesaver';
import { LocalStoreService } from '../local-store/local-store.service';
import { DataObject } from '../../../models/common/data.model';
import { EncryptionService } from '../../auth/encryption.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root'
})
export class HdfcApiService {
	httpOptions = {};

	// for server
	prefixUrl: string = "";

	constructor(
		private http: HttpClient,
		private loaderService: LoaderService,
		private authStore: LocalStoreService,
		public dialogService: DialogService,
		private _FileSaverService: FileSaverService,
		private sanitizer: DomSanitizer,
		private encryption: EncryptionService
	) { }

	get<T>(url: string, showLoader: boolean = true): Observable<T> {
		url = this.prefixUrl + url;

		//console.log("GET: " + url);
		this.httpOptions = {
			headers: new HttpHeaders(
				{
					"show-loader": showLoader.toString(),
				}
			)
		};

		return this.http.get<T>(url, this.httpOptions)
			.pipe(
				map(res => {
					if (showLoader)
						this.loaderService.display(false);
					return res;
				}),
				catchError(this.handleError<T>(url))
			);
	}

	download(url: string, fileName: string, showLoader: boolean = true) {
		url = this.prefixUrl + url;

		//console.log("DOWNLOAD: " + url);
		this.httpOptions = {
			headers: new HttpHeaders(
				{
					"show-loader": showLoader.toString(),
				}
			),
			'observe': 'response',
			'responseType': 'blob'
		};

		this.http.get<HttpResponse<Blob>>(url, this.httpOptions)
			.subscribe(res => {
				this.loaderService.display(false);
				this._FileSaverService.save(res.body, fileName);
			}, error => {
				console.log(error);

				let errMsg: string;

				if (error.error) {
					const reader = new FileReader();

					reader.addEventListener('loadend', (e: any) => {
						const err = JSON.parse(e.srcElement.result);
						console.log(err);
						this.loaderService.display(false);
						if (err && err.ErrorMessage) {
							this.dialogService.error(err.ErrorMessage);
						} else {
							this.dialogService.error("Error during download.");
						}
					});

					reader.readAsText(error.error);
				}
				else {
					errMsg = error.message;
					this.loaderService.display(false);
					this.dialogService.error(errMsg);
				}
			}, () => {
				this.loaderService.display(false);
			});
	}

	downloadPost<D>(url: string, fileName: string, data?: D, showLoader: boolean = true) {
		url = this.prefixUrl + url;

		//console.log("DOWNLOAD POST: " + url);
		this.httpOptions = {
			headers: new HttpHeaders(
				{
					"show-loader": showLoader.toString(),
					'Content-Type': 'application/json'
				}
			),
			'observe': 'response',
			'responseType': 'blob'
		};

		this.http.post<HttpResponse<Blob>>(url, data, this.httpOptions)
			.subscribe(res => {
				this.loaderService.display(false);
				this._FileSaverService.save(res.body, fileName);
			}, error => {
				console.log(error);

				let errMsg: string;

				if (error.error) {
					const reader = new FileReader();

					reader.addEventListener('loadend', (e: any) => {
						const err = JSON.parse(e.srcElement.result);
						this.loaderService.display(false);
						if (err && err.ErrorMessage) {
							this.dialogService.error(err.ErrorMessage);
						} else {
							this.dialogService.error("Error during download.");
						}
					});

					reader.readAsText(error.error);
				}
				else {
					errMsg = error.message;
					this.loaderService.display(false);
					this.dialogService.error(errMsg);
				}
			}, () => {
				this.loaderService.display(false);
			});
	}

	postEncrypted<D, R>(url: string, data?: D, showLoader: boolean = true): Observable<R> {

		const dataObj: DataObject = {
			Data: this.encryption.RSAEncrypt(JSON.stringify(data))
		};
		return this.post<DataObject, R>(url, dataObj, showLoader);
	}

	post<D, R>(url: string, data?: D, showLoader: boolean = true): Observable<R> {
		url = this.prefixUrl + url;

		//console.log("POST: " + url);
		//if (url !== API_LOGIN)
		//	console.log(data);

		this.httpOptions = {
			headers: new HttpHeaders(
				{
					"show-loader": showLoader.toString(),
					'Content-Type': 'application/json'
				}
			)
		};

		return this.http.post<R>(url, data, this.httpOptions)
			.pipe(
				map(res => {
					if (showLoader)
						this.loaderService.display(false);
					return res;
				}),
				catchError(this.handleError<R>(url))
			);
	}

	/**
  * Handle Http operation that failed.
  * Let the app continue.
  */
	private handleError<T>(url = '') {
		return (error: any): Observable<T> => {
			this.loaderService.display(false);

			var errMsg: string;
			console.log(error);
			switch (error.status) {
				case 0:
					errMsg = "Network error. Please check your internet connection.";
					this.dialogService.error(errMsg);
					break;

				case 404:
					errMsg = "Resource not found. Please contact customer support";
					this.dialogService.error(errMsg);
					break;

				case 403:
					errMsg = "You don't have permission to perform this operation.";
					this.dialogService.error(errMsg);
					break;

				case 401:
					errMsg = "Please login.";
					//this.authStore.forceLogout();
					break;
			}

			if (error.status >= 500) {
				console.log(error);
				if (error.error.ErrorMessage)
					errMsg = error.error.ErrorMessage;
				else
					errMsg = error.message;

				//SHOW ERROR MESSAGE DIALOG
				this.dialogService.error(errMsg);
			}

			return throwError(errMsg);
		};
	}

	public getToken(url: string): string {
//		if (url === API_LOGIN)
			return "";

	//	var authToken = this.authStore.getToken();
	//	if (authToken === null) authToken = "";
	//	if (authToken === "") {
	//		this.authStore.forceLogout();
	//	}
	//	else {
	//		return authToken;
	//	}
	}
}
